import {Err} from '@packages/utilities/fp/result';

// the styles are here: public/css/site/site-designer.less
export const CLASS_NAME_LOCALES_WRAPPER = 'w-locales-list';
export const CLASS_NAME_LOCALES_LIST = 'w-locales-items';
export const CLASS_NAME_LOCALES_EMPTY = 'w-locales-empty';
export const CLASS_NAME_LOCALES_LIST_ITEM = 'w-locales-item';
export const CLASS_NAME_LOCALES_HIDE = 'w-locales-hide';

export const LOCALES_MOVE_ERROR = Err('Locale elements cannot be moved.');
export const LOCALES_LIST_ITEM_MOVE_ERROR = Err(
  'This bound element can only be moved within a Locale element.'
);

export const LOCALES_LIST_ITEM_TO_COMPONENT_ERROR = Err(
  'Bound locale elements cannot be converted to components.'
);
export const LOCALES_ACTIVE_ITEM_TO_COMPONENT_ERROR = Err(
  'Bound locale elements cannot be converted to components.'
);
